import { useState } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '平台特色', href: '#features' },
  { label: '视频专区', href: '#media' },
  { label: '热点专题', href: '#carousel' },
  { label: '常见问答', href: '#faq' },
  { label: '热门话题', href: '#topics' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-[72px] flex items-center transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-2 no-underline">
          <span className="text-xl md:text-2xl font-heading text-primary-500 whitespace-nowrap">黑料吃瓜网</span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm font-medium text-foreground-600 hover:text-primary-500 rounded-md transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <nav className="md:hidden absolute top-[72px] left-0 right-0 bg-background-50 border-b border-background-200/70 py-3 px-4 flex flex-col gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}